import { FunctionalComponent, h } from 'preact';
import { useTheme } from 'styled-components';

const CopyIcon: FunctionalComponent = () => {
  const theme = useTheme();

  return (
    <svg width="100%" height="100%" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <path
          d="M15.5,1 L4.5,1 C3.4,1 2.5,1.9 2.5,3 L2.5,16 C2.5,16.55 2.95,17 3.5,17 C4.05,17 4.5,16.55 4.5,16 L4.5,4 C4.5,3.45 4.95,3 5.5,3 L15.5,3 C16.05,3 16.5,2.55 16.5,2 C16.5,1.45 16.05,1 15.5,1 Z M16.09,5.59 L20.92,10.42 C21.29,10.79 21.5,11.3 21.5,11.83 L21.5,21 C21.5,22.1 20.6,23 19.5,23 L8.49,23 C7.39,23 6.5,22.1 6.5,21 L6.51,7 C6.51,5.9 7.4,5 8.5,5 L14.67,5 C15.2,5 15.71,5.21 16.09,5.59 Z M15.5,12 L20,12 L14.5,6.5 L14.5,11 C14.5,11.55 14.95,12 15.5,12 Z"
          id="path-1"
          fill="white"
        />
      </defs>
      <g id="icon/content/file_copy_24px" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <mask id="mask-2" fill="white">
          <use xlinkHref="#path-1" />
        </mask>
        <g fillRule="nonzero" />
        <g id="↳-Color" mask="url(#mask-2)" fill={theme.ui.links.iconColor}>
          <rect id="Rectangle" x="0" y="0" width="24" height="24" />
        </g>
      </g>
    </svg>
  );
};

export default CopyIcon;
